export const date = {
    days: 'วัน',
    months: 'เดือน',
    years: 'ปี',
    minutes: 'นาที',
    minutes_short: 'น.',
    hours: 'ชั่วโมง',
    hours_short: 'ช.ม.',
    date_flase: 'กรุณาระบุวันเกิด',
    month_full: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
    month_short: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
    month_full_arr: [
        { strvalue: "01", strtext: 'มกราคม' },
        { strvalue: '02', strtext: 'กุมภาพันธ์' },
        { strvalue: '03', strtext: 'มีนาคม' },
        { strvalue: '04', strtext: 'เมษายน' },
        { strvalue: '05', strtext: 'พฤษภาคม' },
        { strvalue: '06', strtext: 'มิถุนายน' },
        { strvalue: '07', strtext: 'กรกฎาคม' },
        { strvalue: '08', strtext: 'สิงหาคม' },
        { strvalue: '09', strtext: 'กันยายน' },
        { strvalue: '10', strtext: 'ตุลาคม' },
        { strvalue: '11', strtext: 'พฤศจิกายน' },
        { strvalue: '12', strtext: 'ธันวาคม' }
    ]
}